import Request from "../../../utils/Request"
import { AxiosResponse } from "axios"

/**
 * @param data
 * @param queryString
 * @returns {Promise<AxiosResponse<T>>}
 * @constructor
 */
const GetIfaIndividuals = (data:any[] = false, queryString = {}): Promise<AxiosResponse<T>> => {
	if (queryString) {
		return Request.post( `/advisors/individuals_ifa/paginate?${Request.parseParams(queryString)}`, data);
	}
	return Request.post("/advisors/individuals_ifa/paginate", data);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default GetIfaIndividuals
